var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 39V22.3333L18 14L29 22.3333V39H19.5714V30.6667H16.4286V39H7ZM10.1429 35.6667H13.2857V27.3333H22.7143V35.6667H25.8571V24L18 18.0833L10.1429 24V35.6667Z",
    fill: "#53B374"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5385 19H32.3077V15.6667H35.5385V19Z",
    fill: "#53B374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5385 25.6667H32.3077V22.3333H35.5385V25.6667Z",
    fill: "#53B374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5385 32.3333H32.3077V29H35.5385V32.3333Z",
    fill: "#53B374"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3077 35.6667V39H42V9H21V12.25L24.2308 14.6667V12.3333H38.7692V35.6667H32.3077Z",
    fill: "#53B374"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouses);
export default __webpack_public_path__ + "static/media/houses.0dd18b9cbad19ffc2ba6f4ac7157a903.svg";
export { ForwardRef as ReactComponent };